<div #navbar class="p-0">
  <div class="d-flex toolbar align-items-center px-3" >
    <!-- Menu icon -->
     <div class="pr-3">
       <div *ngIf="!this.layoutService.toolbarDetails.isBack" (click)="openSideNav()" class="menu d-flex align-self-center">
         <span class="material-icons-outlined d-flex"> menu </span>
       </div>
       <div *ngIf="this.layoutService.toolbarDetails.isBack" (click)="goBack()" class="menu d-flex align-self-center">
         <span class="material-icons-outlined d-flex"> arrow_back </span>
       </div>
     </div>

    <!-- Toolbar name -->
    <div class="col toolbarLabel pl-0">
      <div *ngIf="this.layoutService.toolbarDetails.title !== 'Change Password'" class="row primayLabel">
        <span (click)="gotoPage('/dashboard/summary')">{{ this.layoutService.toolbarDetails.title }}</span>
      </div>

    </div>

    <!-- Filter section -->
    <div class="navbar-buttons d-flex" style="gap:0.5rem"> 
      <ng-container *ngFor="let btn of this.layoutService.navbarButtons">
        <button style="background-color: #fff;color:#000080;" class="d-flex align-items-center justify-content-center p-0" (click)="onButtonClick(btn)">
          <span style="font-size: 30px;" class="material-icons">
            {{btn.icon}}
          </span>
        </button> 
      </ng-container>
    </div>

    <div *ngIf="isSuperAdmin" style="height: 2px; width: 100%; background-color: #0057ff"></div>
  </div>
</div>
